export enum COUPON_TYPE {
    VOUCHER = 'VOUCHER',
    COUPON = 'DISCOUNT',
}
export interface Discount {
    type: COUPON_TYPE;
    code: string;
    value: string;
}
